import React from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

export default function Subtitle({title, color}) {
  return (
    <div className="mx-auto max-w-4xl text-center">
      <p className={classNames(color? 'text-blue-primary': 'text-gray-900', 'lg:text-3xl md:font-light tracking-tight sm:text-5xl text-lg px-5 md:px-0')}>
        {title}
      </p>
    </div>
  );
}
